import { AccountRecord } from '../../../api/client'
import InstagramWithFacebookAuthorisationButton from './InstagramWithFacebookAuthorisationButton'

type Props = {
    account: AccountRecord
}

/**
 * Shows the authorisation status of a Instagram profile.
 *
 * This type of profile is added via OAuth, so it will always have an authorisation
 * row, whether or not it's valid. If it has no authorisation then someone
 * has _probably_ been messing with the database, and we should advise the
 * user to contact support.
 */
function InstagramAuthorisation(props: Props) {
    const { account } = props

    let alreadyAuthorised = account.hasAuthorisation
    return (
        <>
            {alreadyAuthorised ? (
                <>
                    <p>This profile is authorised.</p>
                    <div className="mt-4">
                        <p>
                            If there is an issue with authorisation you may need to reauthoise by
                            clicking the button below. Problems with authorisation may prevent Arwen
                            from taking action on content. For example if you get an error when
                            clicking Hide, or none of the severe content queue is hidden.
                        </p>
                        <div className="mt-4">
                            <InstagramWithFacebookAuthorisationButton />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <p>This profile has no authorisation! Please contact support.</p>
                    <div className="mt-4">
                        <InstagramWithFacebookAuthorisationButton />
                    </div>
                </>
            )}
        </>
    )
}

export default InstagramAuthorisation
